
<app-navbar></app-navbar>
<div class="page-title-area page-title-bg1 upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Shopping_Cart' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}</a>-->
        </div>
    </div>
</div>

<!-- End Page Title Area -->
<!-- Start Cart Area -->
<section class="cart-area ptb-100">
    <!-- data-aos="fade-up" data-aos-delay="100"-->
    <div class="container">

        <div class="cart-totals" *ngIf="products.length == 0; else cartForm" style="text-align:center">
            <p>{{'Your_cart_is_currently_empty' | translate }}</p>
            <a routerLink="/shop" class="default-btn">{{'Return_to_Shop' | translate }}</a>
        </div>
        <ng-template #cartForm>
            <form>
                <div class="cart-table table-responsive d-none d-md-block">
                    <div *ngFor="let product of products; let i = index" class="desktop-cart-item">
                        <!-- Image -->
                        <div class="cart-image">
                            <img [src]="apiURL + product.photoPath" alt="product" />
                        </div>

                        <!-- Product Info -->
                        <div class="cart-details">
                            <h5 class="product-name">
                                <ng-template *ngIf="SelectedLanguage == 'ar'; then nameAr; else nameEn"></ng-template>
                                <ng-template #nameAr>{{ product.nameAr }}</ng-template>
                                <ng-template #nameEn>{{ product.name }}</ng-template>
                            </h5>

                            <p class="unit-price">{{ (((product.saleTaxPercentage /100) * product.cartPrice) + product.cartPrice).toFixed(3) }} OMR</p>


                            <div class="quantity-and-actions">
                                <!-- Quantity -->
                                <div class="quantity-counter">
                                    <button class="qty-btn" (click)="minus(product.inItemID)"><i class='bx bx-minus'></i></button>
                                    <input type="text" [value]="product.cartQuantity" disabled />
                                    <button class="qty-btn" (click)="plus(product.inItemID)"><i class='bx bx-plus'></i></button>
                                </div>

                                <!-- Delete -->
                                <button class="delete-btn" (click)="onDeleteItem(product.inItemID)">
                                    <i class='bx bx-trash'></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="desktop-cart-item">

                        <!-- Cart Total Info -->
                        <div class="cart-total">
                            <div class="subtotal-and-total">
                                <span>
                                    {{'Subtotal' | translate }}
                                </span>

                                <span>{{ total | number : '1.3-6'  }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Mobile Cart Layout -->
                <!-- Mobile Cart -->
                <div class="cart-table-mobile d-block d-md-none">
                    <div *ngFor="let product of products; let i = index" class="mobile-cart-item mb-3 p-4" style="background-color: white; border-radius: 10px;">
                        <div class="row align-items-center">
                            <!-- Image Column -->
                            <div class="col-3">
                                <img [src]="apiURL + product.photoPath" alt="item" class="img-fluid" />
                            </div>

                            <!-- Text + Quantity Column -->
                            <div class="col-9">
                                <!-- Product Name -->
                                <h6 class="mb-1" style="font-size: 14px;">
                                    <ng-template *ngIf="SelectedLanguage == 'ar'; then nameAr; else nameEn"></ng-template>
                                    <ng-template #nameAr>{{ product.nameAr }}</ng-template>
                                    <ng-template #nameEn>{{ product.name }}</ng-template>
                                </h6>

                                <div class="d-flex justify-content-between mt-2">
                                    <!-- Quantity Counter -->
                                    <div class="input-counter d-flex align-items-center">
                                        <span class="minus-btn1" (click)="minus(product.inItemID)"><i class='bx bx-minus'></i></span>
                                        <input type="text" min="1" style="font-size: 14px;" [value]="product.cartQuantity" #qtyCart name="qtyCart" disabled class="mx-2 text-center" style="width: 50px;">
                                        <span class="plus-btn2" (click)="plus(product.inItemID)"><i class='bx bx-plus'></i></span>
                                    </div>

                                    <!-- Unit Price -->
                                    <p class="mb-1" style="font-size: 14px;">{{ (((product.saleTaxPercentage /100) * product.cartPrice) + product.cartPrice).toFixed(3) }} OMR</p>


                                </div>


                                <!-- Subtotal & Remove -->
                                <div class="d-flex justify-content-end mt-2">
                                    <!--<span>{{ ( product.cartQuantity * (((product.saleTaxPercentage /100) * product.cartPrice) + product.cartPrice)).toFixed(3) }} OMR</span>-->
                                    <a (click)="onDeleteItem(product.inItemID)" href="javascript:void(0);" class="text-danger"><i class='bx bx-trash'></i></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="desktop-cart-item">

                        <!-- Cart Total Info -->
                        <div class="cart-total">
                            <div class="subtotal-and-total">
                                <span>
                                    {{'Subtotal' | translate }}
                                </span>

                                <span>{{ total | number : '1.3-6'  }}</span>
                            </div>
                        </div>
                    </div>
                </div>



                <!-- data-aos="zoom-in"-->
                <div class="cart-actions">
                    <div class="cart-actions-row">
                        <a routerLink="/shop" class="cart-btn cart-btn-secondary">
                            {{'Continue_Shopping' | translate }}
                        </a>
                        <a routerLink="/checkout" class="cart-btn cart-btn-primary">
                            {{'Proceed_to_Checkout' | translate }}
                        </a>
                    </div>
                </div>

            </form>
        </ng-template>
    </div>
</section>
<!-- End Cart Area -->
